import solver from "./solver"

var R = 0
var analysisType = false

function solveHome(analysisSelection, nNodes, nBar, nodes, barNodes, restrictedDisplacementVector, forceVector, barPropsArray, distributedMagnitudeX, distributedMagnitudeY) {

    if(analysisSelection === "0"){
        analysisType = false
        R = solver(nNodes, nBar, barNodes, restrictedDisplacementVector, forceVector, barPropsArray, analysisType, distributedMagnitudeX, distributedMagnitudeY)
    }

    if(analysisSelection === "1"){
        analysisType = true
        R = solver(nNodes, nBar, barNodes, restrictedDisplacementVector, forceVector, barPropsArray, analysisType, distributedMagnitudeX, distributedMagnitudeY)
    }

    console.log(R)

    return R
}

export default solveHome